import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import PrivateRoute from '../../components/auth/PrivateRoute';
import { CompanySettings, CurrencyModule, DisplaySettingsPage, MyProfile, UserManual, FAQPage } from '../lazyComponents';

/** User settings, help, and SPA catch-all. */
export function SettingsHelpCatchAllRoutes() {
  return (
    <>
      <Route
        path="/settings/company"
        element={
          <PrivateRoute>
            <CompanySettings />
          </PrivateRoute>
        }
      />
      <Route
        path="/settings/currencies"
        element={
          <PrivateRoute>
            <CurrencyModule />
          </PrivateRoute>
        }
      />
      <Route
        path="/settings/display"
        element={
          <PrivateRoute>
            <DisplaySettingsPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <PrivateRoute>
            <MyProfile />
          </PrivateRoute>
        }
      />
      <Route
        path="/help/manual"
        element={
          <PrivateRoute>
            <UserManual />
          </PrivateRoute>
        }
      />
      <Route
        path="/help/faq"
        element={
          <PrivateRoute>
            <FAQPage />
          </PrivateRoute>
        }
      />
      <Route path="*" element={<Navigate to="/app" replace />} />
    </>
  );
}
